import Auth from "./auth";

export default function App() {
  return <Auth/>
}
